import React, { useEffect } from "react";
import "../assets/css/privacy.css";
import Footer from "./footer";
import "../assets/css/about.css";

const AboutUs = () => {
    useEffect(() => {
        setTimeout(() => {
            document
                .getElementById("college-top")
                ?.scrollIntoView({ behavior: "smooth" });
        }, 50);
    }, []);

    return (
        <div className="mainnav-container" id="college-top">
            <div className="pp_container w-100">
                <div className="mainabouthead-st">

                    <img
                        src="https://campushunt.in/images/Office-campushunt.jpg"
                        alt="Top MBA Colleges in Bangalore"
                    />

                    <div>

                        <p>
                            Campushunt.in is a growth-driven education portal focused on
                            maximizing student-potential and helping them plan their higher
                            studies. We aim to help students identify their strengths by offering
                            them career-oriented individual counseling, trainings and educational
                            workshops. Our team of dedicated, student-centric experts assist
                            students to gain admissions in highly selective colleges, business
                            schools and graduate school as well as make intelligent and informed
                            career decisions.

                            Through this portal students, parents and educators can get free,
                            quick and easy access to the best educational institutes and colleges
                            in India. With the right alignment of people, process and technology
                            we help improve institutional effectiveness as well as enable students
                            to make powerful, future-oriented education and career choices.

                            With us, education is enhanced, processes are fast-tracked and
                            students become career-ready.
                        </p>

                        <h3 className="mt-3">Why CampusHunt</h3>

                        <ol>
                            <li>
                                Admission process becomes quick, cost-efficient and easy
                            </li>
                            <li>
                                Get expert assistance in making the right educational choice
                            </li>
                            <li>
                                No service charges or hidden costs - this portal is absolutely free
                            </li>
                            <li>
                                Eliminate costly middlemen - take the clean, fast and leveraged way
                            </li>
                            <li>Value for money - Pay only the lowest fees</li>
                        </ol>

                    </div>

                </div>


                <h3>Vision</h3>

                <p>
                    We envision to become the one-stop destination for students to find
                    the right courses in colleges that are best suited for their
                    requirement. We aim to empower students with the right information to
                    enable them to make informed and fact-based decisions while choosing
                    their colleges and careers. Our aspiration is to become a leader in
                    transforming the higher education industry by integrating learning and
                    technology to offer strategic opportunities for all.
                </p>

                <h3>Mission</h3>

                <p>
                    To revolutionize the future of education and play a role in developing
                    a new breed of vibrant leaders, entrepreneurs and professionals.
                    <br />
                    To create best practices for the higher education industry and create
                    new benchmarks which will benefit students, faculty and academic
                    units.
                    <br />
                    To build a community of dedicated students and education professionals
                    to strengthen the vision of CampusHunt.
                    <br />
                    To provide relevant and comprehensive information that will empower
                    students to compare colleges, institutes and universities across India
                    and make an informed decision.
                    <br />
                    To make education scalable, accessible, affordable, career-focused and
                    high-quality.
                    <br />
                    Get information on the best Universities whenever, wherever you want.
                </p>

                <h3>Additional Information</h3>

                <p>
                    While comparing colleges; explore the facilities, faculty,
                    affiliations and campus placement options of each college. You can
                    also go through the exclusive CampusHunt benefits offered for each
                    college.
                </p>

                <p>
                    Filter the colleges based on the fees, average salary offered through
                    campus placement and other relevant details.
                </p>

                <p>
                    Get to know each college through the photographs of the college
                    campuses.
                </p>

                <p>
                    During the confirmation call from our certified higher studies
                    advisors, clarify all your doubts regarding the course, fee structure,
                    education loans etc. This way, you can make a better choice.
                </p>

                <p>
                    On the day of admission, don't forget to bring your completed
                    application form and mandatory documents (Educational certificates, ID
                    proof etc).
                </p>

                <p>Please note that CampusHunt does not take any fee from the students.</p>

                <p>
                    <strong>
                        No more waiting in queues… now admissions to top-notch colleges are
                        only a few clicks away!
                    </strong>
                </p>
            </div>
            <Footer />
        </div>
    );
};

export default AboutUs;